export const filterNumber = (
  val: string,
  min: number,
  max: number,
  length: number,
): string | null => {
  let newVal: number | null = Number(val.replace(/[^0-9]/, ''));
  newVal = newVal > max ? null : newVal;
  if (newVal !== null) {
    newVal = newVal < min ? null : newVal;
  }
  let result: string | null = null;
  if (newVal !== null) {
    result =
      String(newVal).length < length
        ? `0${newVal.toString()}`
        : newVal.toString();
  }
  return result;
};
